<div class="all">
    <div class="circuito mb-md-2 mb-2">
        <div class="row col-12 col-md-12 mb-md-3 mb-2 mt-0 pt-md-4 pb-md-3 px-md-4 p-3 d-flex justify-content-between align-items-start">

            <div class="d-flex align-items-start col-md-8 col-12 gap-3 px-md-0">
                <div class="img_circuito me-3">
                    <img [src]="circuito?.ImagemPrincipal" alt="Imagem do circuito" style="width: 225px; max-height: 300px; min-height: 0px !important; object-fit: contain;" />
                </div>

                <div>
                    <h4 class="text-start mb-1">
                        {{ circuito?.Titulo }}
                        <span>
                            <!-- *ngIf="busca.usuario.EmpresaId != null" -->
                            ({{ circuito.Fornecedor }}/{{ circuito.CodigoCircuito }})
                        </span>
                    </h4>
                    <div class="cidade-pais">
                        <p><strong>{{ "Início em" | translate }}:</strong> {{ circuito?.CidadeInicio }}</p>
                        <p><strong>{{ "Cidades percorridas" | translate }}:</strong> {{ circuito?.CidadesPercorridas }}</p>
                        <p><strong>{{ "Países percorridos" | translate }}:</strong> {{ circuito?.PaisesPercorridos }}</p>
                    </div>
                </div>
            </div>

            <div class="duracao-refeicao d-flex flex-row text-end col-md-4 col-12">
                <div class="text-start">
                    <div class="me-md-3 me-3">
                        <strong>{{ "Duração" | translate }}:</strong>
                        {{ circuito?.Duracao }} {{ "Dias" | translate }}
                    </div>
                    <div *ngIf="circuito?.Barco" class="me-md-3 me-3">
                        <strong>{{ "Barco" | translate }}:</strong>
                        {{ circuito?.BarcoNome }}
                    </div>
                </div>
                <div class="text-start">
                    <div *ngIf="circuito?.Refeicoes != undefined && circuito?.Refeicoes > 0">
                        <strong>{{ "Refeições" | translate }}:</strong>
                        {{ circuito?.Refeicoes }}
                    </div>
                    <div *ngIf="circuito?.Rio">
                        <strong>{{ "Rio" | translate }}:</strong>
                        {{ circuito?.RioNome }}
                    </div>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="d-flex flex-row justify-content-around align-items-center col-12 col-md-12 mb-md-3 mb-md-3">
                <div>
                    <a class="text-muted" *ngIf="circuito?.LinkPDF?.length > 0" [href]="circuito.LinkPDF" target="_blank"
                        data-toggle="tooltip" data-placement="top" title="Link para baixar o pdf">
                        <i class="fa fa-download" aria-hidden="true"></i>
                            <span class="link mx-md-2 mx-2">{{ "Baixe o PDF do Circuito" | translate }}</span>
                    </a>
                </div>
                <div>
                    <a class="text-muted" *ngIf="circuito?.LinkPDF?.length > 0" [href]="circuito.LinkWord"
                        target="_blank" data-toggle="tooltip" data-placement="top" title="Link Word">
                        <i class="fa fa-download" aria-hidden="true"></i>
                            <span class="link mx-md-2 mx-2">{{"Página Word" | translate}}</span>
                    </a>
                </div>
                <div class="categoria" *ngIf="circuito?.Categorias?.length > 0">
                    <strong>{{"Categorias" | translate}}:</strong>
                    <span> {{circuito?.Categorias}}</span>
                </div>
                <div>
                    <div>
                      <p class="valor">{{"Valor Aproximado" | translate}}:</p>
                      <strong class="moeda">{{circuito?.MoedaListagem?.Sigla}} {{circuito?.ValorInicialListagem | currency :'BRL':'':'1.2-2'}}</strong>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 col-12">
              <div class="text-end me-md-5 me-md-4 mb-md-3 mb-3">
                <label class="btn btn-success pt-md-2 pb-md-2 px-md-3 pe-md-3 p-2">
                  <input type="checkbox" class="checked-btn" (click)="abrirModal()" />
                  <span style="font-size: 17px;">{{'SELECIONAR' | translate}}</span>
                </label>
              </div>
            </div>
        </div>

    </div>
</div>
